import { BaseIconProps, IconHexColor } from "../../types/styles";

interface ToggleOffIconProps extends BaseIconProps {
    customStroke?: IconHexColor;
}

const ToggleOffIcon = ({
    id,
    className,
    size = 1.4,
    customColor,
    customStroke,
    ...rest
}: ToggleOffIconProps) => {
    const fill = customColor ?? "var(--neutral-200)";
    const stroke = customStroke ?? "var(--neutral-100)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-toggle-off"}
            className={className}
            width={63 / Number(size)}
            height={38 / Number(size)}
            viewBox="0 0 63 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0" y="2" width="63" height="34" rx="17" fill={fill} />
            <circle
                cx="19"
                cy="19"
                r="13"
                fill="white"
                stroke={stroke}
                strokeWidth="1"
            />
        </svg>
    );
};

export default ToggleOffIcon;
